<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-04 15:03:04
 * @LastEditors: shenlin
 * @LastEditTime: 2021-12-20 14:58:13
-->
<template>
  <div class="info-div">
    <div class="info-body">
      <table class="info-table">
        <tr>
          <th>企业名称</th>
          <td>{{ toHtmlStr(entInfo.entName) }}</td>
          <th>注册资本</th>
          <td>{{ toHtmlStr(entInfo.regCap) }}万元</td>
        </tr>
        <tr>
          <th>经营状态</th>
          <td>{{ toHtmlStr(entInfo.entStatus) }}</td>
          <th>企业类型</th>
          <td>{{ toHtmlStr(entInfo.entType) }}</td>
        </tr>
        <tr>
          <th>统一社会信用代码</th>
          <td>{{ toHtmlStr(entInfo.creditCode) }}</td>
          <th>成立日期</th>
          <td>{{ toHtmlStr(entInfo.openFrom) }}</td>
        </tr>
        <tr>
          <th>法定代表人</th>
          <td>{{ toHtmlStr(entInfo.frName) }}</td>
          <th>核准时间</th>
          <td>{{ toHtmlStr(entInfo.apprDate) }}</td>
        </tr>
        <tr>
          <th>行业门类名称</th>
          <td>
            {{ toHtmlStr(entInfo.industryPhyName) }}
          </td>
          <th>经营期限</th>
          <td>{{ toHtmlStr(entInfo.openTo) }}</td>
        </tr>
        <tr>
          <th>注册代码</th>
          <td>{{ toHtmlStr(entInfo.regNo) }}</td>
          <th>登记机关</th>
          <td>{{ toHtmlStr(entInfo.regOrg) }}</td>
        </tr>
        <tr>
          <th>国民经济行业名称（代码）</th>
          <td>{{ toHtmlStr(entInfo.industryCode) }}</td>
          <th>所属地区</th>
          <td>
            {{ toHtmlStr(entInfo.province) }}{{ toHtmlStr(entInfo.city)
            }}{{ toHtmlStr(entInfo.county) }}
          </td>
        </tr>
        <tr class="tr-opeation">
          <th>经营范围</th>
          <td :colspan="3">{{ toHtmlStr(entInfo.operateScope) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { toHtmlStr } from '@utils'
export default {
  name: 'Information',
  data() {
    return {
      toHtmlStr,
    }
  },
  props: {
    entInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less">
</style>
